module.exports = __webpack_public_path__ + "static/img/GH@2x.e3f97ad4.jpg";